import axios from 'axios';
import apiConfig from '../api.config';

export default function userListRequest({ ownerId }) {
  const {
    host,
    URIs: { usersList },
  } = apiConfig;

  const uri = `${host}${usersList}/${ownerId}`;

  return axios
    .get(uri, {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
